import marketService from 'services/market'
import { formatNumber } from '../../../assets/scripts/utils/format-number'

const updateRates = (): void => {
  const pairsPLN = marketService.getMarketBrief().filter((el) => el.pair.includes('PLN'))

  for (const pair of pairsPLN) {
    const { buyNow, sellNow } = pair.directExchangeOffers
    const $elementToUpdate = document.querySelector<HTMLElement>(`[data-rates-pair="${pair.pair}"]`)
    if ($elementToUpdate) {
      const $buyElement = $elementToUpdate.querySelector<HTMLElement>('[data-rates-pair-buy]')
      const $sellElement = $elementToUpdate.querySelector<HTMLElement>('[data-rates-pair-sell]')
      if ($buyElement && $sellElement) {
        $buyElement.innerHTML = formatNumber(buyNow, 4)
        $sellElement.innerHTML = formatNumber(sellNow, 4)
      }
    }
  }

  changeOfflineOverlayState(true)
}

const changeOfflineOverlayState = (state): void => {
  const $offlineBoxElement = document.querySelector<HTMLElement>('[currency-widget-offline]')
  if ($offlineBoxElement) {
    $offlineBoxElement.hidden = state
  }
}
const showOfflineMode = (): void => {
  changeOfflineOverlayState(false)
}

const initWidgetUpdateMechanism = (): void => {
  const $rateWidget = document.querySelector<HTMLElement>('[data-rates-widget]')
  if ($rateWidget) {
    marketService.fetchRates()
    setInterval(marketService.fetchRates, 10 * 1000)
  }
  window.addEventListener('marketBrief fetched', updateRates)
  window.addEventListener('marketBrief fetch fail', showOfflineMode)
}

export function initRatesWidget(): void {
  initWidgetUpdateMechanism()
}
